// The quote payload carries no family field, so the pairing of tiers onto
// customer-facing cards is stated here.
const PLAN_FAMILIES: Record<string, string> = {
  'regular:': 'regular',
  'bucket:independent_host_1_2': 'independent_host',
  'bucket:independent_host_3_4': 'independent_host',
  'bucket:operator': 'operator',
  'bucket:manager': 'manager',
  'payg:tier_1_4': 'independent_host',
  'payg:tier_5_10': 'operator',
};

export function tierId(planType: string, planTier: string | null): string {
  return `${planType}:${planTier ?? ''}`;
}

export function planFamily(planType: string, planTier: string | null): string {
  const id = tierId(planType, planTier);

  return PLAN_FAMILIES[id] ?? id;
}

export function isKnownPlanFamily(
  planType: string,
  planTier: string | null,
): boolean {
  return tierId(planType, planTier) in PLAN_FAMILIES;
}
